import React from 'react'
import { useTheme } from '@material-ui/core/styles'

type LinkedPolygonProps = {
  points: string
  href: string
}

const LinkedPolygon: React.FC<LinkedPolygonProps> = ({ points, href }) => {
  const theme = useTheme()

  return (
    <a href={href} rel="noopener noreferrer">
      <polygon
        points={points}
        fill={theme.palette.primary.main}
        fillOpacity={0.3}
        stroke="none"
      />
    </a>
  )
}

export default LinkedPolygon
